import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { HistoricoLecturasService } from "../../servicios/historico-lecturas.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { HistoricoLecturas, HistoricoLecturasInput} from "../../entidades/entidades";

@Component({
  selector: 'app-historico-lecturas-grid',
  templateUrl: './historico-lecturas-grid.component.html',
  styleUrls: ['./historico-lecturas-grid.component.css']
})
export class HistoricoLecturasGridComponent implements OnInit, OnChanges {
  muestraMensaje = new MuestraMensaje();
  historicoLecturas: HistoricoLecturasInput;
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  _historicoLecturas: HistoricoLecturasInput = new HistoricoLecturasInput;

  public idAgua: number;
  public cuentaAgua: string;

  @Input('historicoLecturasInput') historicoLecturasInput : HistoricoLecturasInput;


  constructor( private historicoLecturasService: HistoricoLecturasService,) { }

  ngOnInit():  void {
    
    

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {field: "operacion",header: "", ordenar: false, styleHeader: "width: 30px;"},
      {field: "anio", header: "Año",ordenar: true, styleHeader: "width: 150px;",},
      {field: "mes", header: "Mes",ordenar: true, styleHeader: "width: 150px;",},
      {field: "lecturaInicial", header: "Lectura Inicial",ordenar: true, styleHeader: "width: 150px;",},
      {field: "lecturaFinal", header: "Lectura Final",ordenar: true, styleHeader: "width: 150px;",},
      {field: "m3", header: "M3",ordenar: true, styleHeader: "width: 150px;",},
      {field: "val", header: "Validacion",ordenar: true, styleHeader: "width: 150px;",},
      {field: "fechaLectura", header: "Fecha Lecturas",ordenar: true, styleHeader: "width: 150px;",},
      {field: "acciones", header: "",ordenar: false, styleHeader: "width: 30px;",},
    ];
    
  

     this.getAllHistoricoLecturas();

  }

  ngOnChanges(changes: SimpleChanges): void {
    // Este método se activa cada vez que la entrada 'myInput' cambia.
    debugger;
    this.historicoLecturas = this.historicoLecturasInput;
  }
  
  async getAllHistoricoLecturas() {
    try {
        this.historicoLecturas = this.historicoLecturasInput;
        console.log("this.historicoLecturas", this.historicoLecturas);
        
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllHistoricoLecturas");
    }
  }

}
